import { RemoteGetStudentReportDailyWorkload } from 'data/usecases';
import { HandleStudentReportDailyWorkload } from 'domain/usecases';
import { makeApiUrlStudentReportDailyWorkload } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetStudentReportDailyWorkload =
  (): HandleStudentReportDailyWorkload =>
    new RemoteGetStudentReportDailyWorkload(
      makeApiUrlStudentReportDailyWorkload(),
      makeAxiosHttpClient(),
    );
